import { z } from 'zod';

export const incomeFixedSchema = z.object({
  indexer: z.string({ required_error: 'Campo obrigatório' }),
  indexerFee: z.number({
    invalid_type_error: 'Valor inválido',
    required_error: 'Campo obrigatório',
  }),
  grossUp: z.number().nullable().optional(),
});

// extracting the type
export type IncomeFixedSchemaType = z.infer<typeof incomeFixedSchema>;
